/* eslint-disable jsx-a11y/anchor-is-valid */

import * as React from "react";
import {Modal, FormGroup} from "react-bootstrap";
import { Alert } from "../ui/form/Alert";

interface Props { 
    show?: boolean,
    okLabel: string,
    cancelLabel?: string,
    heading: string,
    description?: string, 
    okClassName?: string,
    cancelClassName?: string,
    hideCancelButton? : boolean,
    onOk: () => void, 
    onCancel?: () => void,
    descriptionAlert? : boolean, 
    showCloseButton?:boolean,
    showDescriptionTextArea?:boolean
}

export class ConfirmModal extends React.Component<Props, {}>{

    async onCancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    async doOk() {
        this.props.onOk();
    }

    getActions() {
        let btnCancelClass = this.props.cancelClassName ? this.props.cancelClassName : "btn-primary";
        let btnClass = this.props.okClassName ? this.props.okClassName : "btn-danger";
        let btnCancel = this.props.cancelLabel ? this.props.cancelLabel : "Cancel";
        let hideCancelButton = this.props.hideCancelButton ? this.props.hideCancelButton : false;
        return (
            <FormGroup className="form-group">
                <div> 
                    {!hideCancelButton && 
                        ( <a  className={`btn ${btnCancelClass}`} onClick={this.onCancel.bind(this)}>{btnCancel}</a>)
                    }
                    <a  className={`btn ${btnClass}`} onClick={this.doOk.bind(this)}>{this.props.okLabel}</a>
                </div>
            </FormGroup>
        );
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.onCancel.bind(this)} aria-labelledby="contained-modal-title">
                <Modal.Header  closeButton={this.props.showCloseButton}>
                    <Modal.Title id="contained-modal-title">{this.props.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    { (this.props.descriptionAlert===undefined || this.props.descriptionAlert===false)&& (this.props.showDescriptionTextArea===undefined || this.props.showDescriptionTextArea===false) && (
                        <div>{this.props.description}</div>
                    )}
                    { (this.props.descriptionAlert===undefined || this.props.descriptionAlert===false)&& (this.props.showDescriptionTextArea===true) && (
                        <div><textarea className={"form-control chat-input"} rows={10} cols={70} maxLength={1000} disabled={true}>{this.props.description}</textarea></div>
                    )}
                    {this.props.descriptionAlert===true && (
                        <Alert type="success" text={this.props.description} />
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {this.getActions()}
                </Modal.Footer>
            </Modal>
       );
    }
}